import { OAuthResponse } from '@ul/api';
import { UserInfo } from '@ul/api/lib/models/UserInfo';

export const toUserInfoModel = (response: OAuthResponse): UserInfo | undefined => {
    if (response?.userInfo) {
        const info: UserInfo = {
            firstName: response.userInfo.firstName || '',
            lastName: response.userInfo.lastName || '',
        };

        return info;
    }
    return undefined;
};
